import transferLogo from './transfer.svg';
import transferLogoWhite from './transfer-white.svg';

export const Icons = {
  transferLogo,
  transferLogoWhite,
};
